export default __webpack_public_path__ + "static/media/img-error-purple.8b0303a8.svg";